// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v7.35.1
// source: odoo/invoice.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "pc.proto.odoo.invoice";

export interface InvoiceAttachment {
  name: string;
  id: number;
  type: InvoiceAttachment_Type;
}

export enum InvoiceAttachment_Type {
  UNKNOWN = 0,
  INVOICE_XRECHNUNG = 1,
  INVOICE_PDF = 2,
  ITEMIZED_BILL_PDF = 3,
  UNRECOGNIZED = -1,
}

export function invoiceAttachment_TypeFromJSON(object: any): InvoiceAttachment_Type {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return InvoiceAttachment_Type.UNKNOWN;
    case 1:
    case "INVOICE_XRECHNUNG":
      return InvoiceAttachment_Type.INVOICE_XRECHNUNG;
    case 2:
    case "INVOICE_PDF":
      return InvoiceAttachment_Type.INVOICE_PDF;
    case 3:
    case "ITEMIZED_BILL_PDF":
      return InvoiceAttachment_Type.ITEMIZED_BILL_PDF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InvoiceAttachment_Type.UNRECOGNIZED;
  }
}

export function invoiceAttachment_TypeToJSON(object: InvoiceAttachment_Type): string {
  switch (object) {
    case InvoiceAttachment_Type.UNKNOWN:
      return "UNKNOWN";
    case InvoiceAttachment_Type.INVOICE_XRECHNUNG:
      return "INVOICE_XRECHNUNG";
    case InvoiceAttachment_Type.INVOICE_PDF:
      return "INVOICE_PDF";
    case InvoiceAttachment_Type.ITEMIZED_BILL_PDF:
      return "ITEMIZED_BILL_PDF";
    case InvoiceAttachment_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Invoice {
  id: number;
  name: string;
  date: string;
  amountUntaxed: number;
  product: string;
  quantity: number;
  customerId: number;
  customerName: string;
  applianceId: number;
  applianceName: string;
  attachments: InvoiceAttachment[];
}

export interface GetInvoicesResponse {
  invoices: Invoice[];
}

export interface GetInvoiceAttachmentResponse {
  presignedUrl: string;
}

function createBaseInvoiceAttachment(): InvoiceAttachment {
  return { name: "", id: 0, type: 0 };
}

export const InvoiceAttachment: MessageFns<InvoiceAttachment> = {
  encode(message: InvoiceAttachment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.id !== 0) {
      writer.uint32(16).uint64(message.id);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InvoiceAttachment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInvoiceAttachment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InvoiceAttachment {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      type: isSet(object.type) ? invoiceAttachment_TypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: InvoiceAttachment): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.type !== 0) {
      obj.type = invoiceAttachment_TypeToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InvoiceAttachment>, I>>(base?: I): InvoiceAttachment {
    return InvoiceAttachment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InvoiceAttachment>, I>>(object: I): InvoiceAttachment {
    const message = createBaseInvoiceAttachment();
    message.name = object.name ?? "";
    message.id = object.id ?? 0;
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseInvoice(): Invoice {
  return {
    id: 0,
    name: "",
    date: "",
    amountUntaxed: 0,
    product: "",
    quantity: 0,
    customerId: 0,
    customerName: "",
    applianceId: 0,
    applianceName: "",
    attachments: [],
  };
}

export const Invoice: MessageFns<Invoice> = {
  encode(message: Invoice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.date !== "") {
      writer.uint32(26).string(message.date);
    }
    if (message.amountUntaxed !== 0) {
      writer.uint32(33).double(message.amountUntaxed);
    }
    if (message.product !== "") {
      writer.uint32(42).string(message.product);
    }
    if (message.quantity !== 0) {
      writer.uint32(48).uint64(message.quantity);
    }
    if (message.customerId !== 0) {
      writer.uint32(56).uint64(message.customerId);
    }
    if (message.customerName !== "") {
      writer.uint32(66).string(message.customerName);
    }
    if (message.applianceId !== 0) {
      writer.uint32(72).uint64(message.applianceId);
    }
    if (message.applianceName !== "") {
      writer.uint32(82).string(message.applianceName);
    }
    for (const v of message.attachments) {
      InvoiceAttachment.encode(v!, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Invoice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInvoice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.date = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.amountUntaxed = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.quantity = longToNumber(reader.uint64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.customerId = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.customerName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.applianceId = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.applianceName = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.attachments.push(InvoiceAttachment.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Invoice {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      date: isSet(object.date) ? globalThis.String(object.date) : "",
      amountUntaxed: isSet(object.amountUntaxed) ? globalThis.Number(object.amountUntaxed) : 0,
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      customerId: isSet(object.customerId) ? globalThis.Number(object.customerId) : 0,
      customerName: isSet(object.customerName) ? globalThis.String(object.customerName) : "",
      applianceId: isSet(object.applianceId) ? globalThis.Number(object.applianceId) : 0,
      applianceName: isSet(object.applianceName) ? globalThis.String(object.applianceName) : "",
      attachments: globalThis.Array.isArray(object?.attachments)
        ? object.attachments.map((e: any) => InvoiceAttachment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Invoice): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.date !== "") {
      obj.date = message.date;
    }
    if (message.amountUntaxed !== 0) {
      obj.amountUntaxed = message.amountUntaxed;
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.quantity !== 0) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.customerId !== 0) {
      obj.customerId = Math.round(message.customerId);
    }
    if (message.customerName !== "") {
      obj.customerName = message.customerName;
    }
    if (message.applianceId !== 0) {
      obj.applianceId = Math.round(message.applianceId);
    }
    if (message.applianceName !== "") {
      obj.applianceName = message.applianceName;
    }
    if (message.attachments?.length) {
      obj.attachments = message.attachments.map((e) => InvoiceAttachment.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Invoice>, I>>(base?: I): Invoice {
    return Invoice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Invoice>, I>>(object: I): Invoice {
    const message = createBaseInvoice();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.date = object.date ?? "";
    message.amountUntaxed = object.amountUntaxed ?? 0;
    message.product = object.product ?? "";
    message.quantity = object.quantity ?? 0;
    message.customerId = object.customerId ?? 0;
    message.customerName = object.customerName ?? "";
    message.applianceId = object.applianceId ?? 0;
    message.applianceName = object.applianceName ?? "";
    message.attachments = object.attachments?.map((e) => InvoiceAttachment.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetInvoicesResponse(): GetInvoicesResponse {
  return { invoices: [] };
}

export const GetInvoicesResponse: MessageFns<GetInvoicesResponse> = {
  encode(message: GetInvoicesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.invoices) {
      Invoice.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInvoicesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInvoicesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.invoices.push(Invoice.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetInvoicesResponse {
    return {
      invoices: globalThis.Array.isArray(object?.invoices) ? object.invoices.map((e: any) => Invoice.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetInvoicesResponse): unknown {
    const obj: any = {};
    if (message.invoices?.length) {
      obj.invoices = message.invoices.map((e) => Invoice.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetInvoicesResponse>, I>>(base?: I): GetInvoicesResponse {
    return GetInvoicesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetInvoicesResponse>, I>>(object: I): GetInvoicesResponse {
    const message = createBaseGetInvoicesResponse();
    message.invoices = object.invoices?.map((e) => Invoice.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetInvoiceAttachmentResponse(): GetInvoiceAttachmentResponse {
  return { presignedUrl: "" };
}

export const GetInvoiceAttachmentResponse: MessageFns<GetInvoiceAttachmentResponse> = {
  encode(message: GetInvoiceAttachmentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.presignedUrl !== "") {
      writer.uint32(10).string(message.presignedUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInvoiceAttachmentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInvoiceAttachmentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.presignedUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetInvoiceAttachmentResponse {
    return { presignedUrl: isSet(object.presignedUrl) ? globalThis.String(object.presignedUrl) : "" };
  },

  toJSON(message: GetInvoiceAttachmentResponse): unknown {
    const obj: any = {};
    if (message.presignedUrl !== "") {
      obj.presignedUrl = message.presignedUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetInvoiceAttachmentResponse>, I>>(base?: I): GetInvoiceAttachmentResponse {
    return GetInvoiceAttachmentResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetInvoiceAttachmentResponse>, I>>(object: I): GetInvoiceAttachmentResponse {
    const message = createBaseGetInvoiceAttachmentResponse();
    message.presignedUrl = object.presignedUrl ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
